require('angular')
require('angular-route')
require('angular-ui-map')
require('ui-cropper')

require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/error-handler/error-handler-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/form/form-module')
require('../components/animate/animate-module')
require('../components/account/account-module')
require('../components/auth/auth-module')


#load Templates
require('./registration.jade')
require('./index.jade')
require('./detail.jade')
require('./score_submit.jade')
require('./event-rank.jade')
require('./edit.jade')

# Load Css
require('../../../sass/web/html/_group_event.scss')
require('../../../sass/web/html/_group_event_list.scss')
require('../../../sass/web/html/_group_event_detail.scss')
require('../../../sass/web/html/_group_event_rank.scss')

GroupEventEditCtrl = require('./group-event-edit-controller')
GroupEventRegistCtrl = require('./group-event-regist-controller')
GroupEventListCtrl   = require('./group-event-list-controller')
GroupEventDetailCtrl = require('./group-event-detail-controller')
GroupEventSubmitScoreCtrl = require('./group-event-submit-score-controller')
CourseListModalCtrl = require('./course-list-modal-controller')
GroupEventRankCtrl = require('./group-event-rank-controller')
GroupRegisDataService = require('../groups/group-registration-data-service')
GroupUploadDataService = require('../groups/group-upload-data-service')
GroupEventService = require('./group-event-service')
EventScoreCardDirective = require('./event-score-card-directive/event-score-card-directive')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-form'
  'gnp-flash'
  'gnp-animate'
  'gnp-error-handler'
  'uiCropper'
]

angular.module 'gnp-app-group-event', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')

    $routeProvider.when '/group-event/registration',
      controller: 'GroupEventRegistCtrl'
      templateUrl: 'web/group-event/registration.jade'
      title: '_GROUP_EVENT.TITLE_CREATE'
      permission:
        signInRequired: true
      resolve:
        groupInfo: ['groupRegisDataService', '$route' , '$location' , (groupRegisDataService ,$route ,$location ) ->
          if $route.current.params.id is undefined
            return
          groupRegisDataService.getGroup($route.current.params.id)
            .then (data) ->
              data
            , (error) ->
              $location.path('/groups')
        ]
    .when '/group-event/:id/edit',
      controller: 'GroupEventEditCtrl'
      templateUrl: 'web/group-event/edit.jade'
      title: '_GROUP_EVENT.TITLE_EDIT'
      permission:
        signInRequired: true
      resolve:
        detailData: ['groupEventService', '$route', '$location' , (groupEventService ,$route ,$location ) ->
          if $route.current.params.id is undefined
            return
          groupEventService.getDataEventDetail($route.current.params.id)
            .then (data) ->
              data
            , (error) ->
              $location.path('/groups')
        ]
    .when '/group-event/:id/scorecards',
      controller: 'GroupEventSubmitScoreCtrl'
      templateUrl: 'web/group-event/score_submit.jade'
      permission:
        signInRequired: true
      resolve:
        detailData: ['groupEventService', '$route', '$location' , (groupEventService ,$route ,$location ) ->
          if $route.current.params.id is undefined
            return
          groupEventService.getDataEventDetail($route.current.params.id)
            .then (data) ->
              data
            , (error) ->
              $location.path('/groups')
        ]
    .when '/group-event/:id/ranking',
      controller: 'GroupEventRankCtrl'
      templateUrl: 'web/group-event/event-rank.jade'
      permission:
        signInRequired: true
      resolve:
        detailData: ['groupEventService', '$route', '$location' , (groupEventService ,$route ,$location ) ->
          if $route.current.params.id is undefined
            return
          groupEventService.getDataEventDetail($route.current.params.id)
            .then (data) ->
              data
            , (error) ->
              $location.path('/groups')
        ]
    .when '/group-event/:id',
      controller: 'GroupEventDetailCtrl'
      templateUrl: 'web/group-event/detail.jade'
      permission:
        signInRequired: true
      resolve:
        detailData: ['groupEventService', '$route', '$location' , (groupEventService ,$route ,$location ) ->
          if $route.current.params.id is undefined
            return
          groupEventService.getDataEventDetail($route.current.params.id)
            .then (data) ->
              data
            , (error) ->
              $location.path('/groups')
        ]
  ]
  .factory 'groupRegisDataService', GroupRegisDataService
  .factory 'groupUploadDataService', GroupUploadDataService
  .factory 'groupEventService', GroupEventService
  .controller 'GroupEventEditCtrl', GroupEventEditCtrl
  .controller 'GroupEventRegistCtrl', GroupEventRegistCtrl
  .controller 'GroupEventListCtrl', GroupEventListCtrl
  .controller 'GroupEventDetailCtrl', GroupEventDetailCtrl
  .controller 'GroupEventSubmitScoreCtrl', GroupEventSubmitScoreCtrl
  .controller 'CourseListModalCtrl', CourseListModalCtrl
  .controller 'GroupEventRankCtrl', GroupEventRankCtrl
  .directive 'eventRankScoreCard', EventScoreCardDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-module.coffee